<template>
  <!-- 1.all-container-start -->
  <div class="all-container">
    <div class="top borderShadow" v-if="isShow">
      <div class="item">
        <div class="top flexStyle1">
          <div class="center c-animation">客户名称</div>
        </div>
        <div class="bottom">
          {{ userInfo.customerName || "客户名称" }}
        </div>
      </div>
      <div class="item">
        <div class="top flexStyle1">
          <div class="center c-animation">余额</div>
        </div>
        <div class="bottom">{{ to_f(userInfo.balance || "0.00") }}</div>
      </div>
    </div>
  </div>
  <!-- 1.all-container-end -->
</template>

<script>
export default {
  data() {
    // 1.data
    return {
      userInfo: {}, // 1.1.userInfo
      timer: null, // 1.2.定时器对象，用于查询用户信息直到查询到位置
      isShow: true,
      interval: null,
    };
  },

  methods: {},
  components: {},

  mounted() {
    this.timer = setInterval(() => {
      if (localStorage.userInfo) {
        clearInterval(this.timer);
        this.userInfo = JSON.parse(localStorage.userInfo);
        // console.log(this.userInfo);
      }
    }, 20);
  },
};
</script>

<style lang="scss" scoped>
@import "./userInfo.scss";
</style>
